import { useMemo } from "react";
import { NavigateOptions, useNavigate } from "react-router";

import { RouterControl } from "../types";

export function useRouter(): RouterControl {
  const navigate = useNavigate();

  const router = useMemo(
    () => ({
      back: () => navigate(-1),
      forward: () => navigate(1),
      push: (href: string, options?: NavigateOptions) =>
        navigate(href, options),
      replace: (href: string) => navigate(href, { replace: true }),
    }),
    [navigate],
  );

  return router;
}
